import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CourseCard from '../components/CourseCard';
import { publicAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { EmptyState } from '../components/ui';

export default function InstructorPage() {
  const { memberId } = useParams();
  const [person, setPerson] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    publicAPI.instructor(memberId)
      .then(({ data }) => setPerson(data))
      .catch(() => setMissing(true));
  }, [memberId]);

  if (missing) return <p className="py-16 text-center text-sm text-lms-muted">{t('Instructor not found.')}</p>;
  if (!person) return <p className="text-sm text-lms-muted">{t('Loading…')}</p>;

  return (
    <div className="space-y-8">
      <header className="flex items-center gap-4">
        {person.avatar ? (
          <img src={person.avatar} alt="" className="h-16 w-16 rounded-full object-cover" />
        ) : (
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-lms-raised text-xl font-semibold text-lms-faint">
            {(person.name || '?').slice(0, 1)}
          </span>
        )}
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">{person.name}</h1>
          <p className="text-sm text-lms-muted">
            <span className="lms-num">{person.courses.length}</span> {t('courses')}
          </p>
        </div>
      </header>
      {person.courses.length === 0 ? (
        <EmptyState>{t('No published courses yet — check back soon.')}</EmptyState>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {person.courses.map((c) => <CourseCard key={c.id} course={c} />)}
        </div>
      )}
    </div>
  );
}
